import InvestmentsFormDropdown from './InvestmentsFormDropdown';

export default InvestmentsFormDropdown;
